<prox-main [parent]="this" [bodyTemplate]="bodyTemplate"></prox-main>
<ng-template #bodyTemplate>
  <div *ngIf="isEditable()" class="qb-list-actions">
    <p-button (click)="onAdd()" size="small" label="Add Account" icon="pi pi-plus"></p-button>
  </div>
  <div class="qb-layout-grid">
    <prox-ag-grid gridId="accountsGrid" [gridOptions]="gridOptions" [rowData]="accounts"></prox-ag-grid>
  </div>
</ng-template>
